<template>
    <div class="email-modal">
        <button class="modal-close-button" @click="closeModal">X</button>
        <div class="email-form">
            <form @submit.prevent="handleSubmit" v-if="!formSubmitted">
            <h1>Share your custom tray</h1><br />
            <img :src="trayImageUrl" alt="Tray Preview" v-if="trayImageUrl" width="50%" />
            <br class="cleaner" />
            <input type="email" v-model="recipientEmail" placeholder="Recipient's Email" required>
            <input type="email" v-model="senderEmail" placeholder="Your Email" required>
            <textarea v-model="message" placeholder="Message"></textarea>
            <button type="submit" class="quoteButton" :disabled="isSubmitting">
              {{ isSubmitting ? 'Sending...' : 'Send Email' }}
            </button>
            </form>
            <div v-if="formSubmitted">
                <p :class="{'success-message': submissionSuccess, 'error-message': !submissionSuccess}">
                    {{ submissionMessage }}
                </p>
            </div>
        </div>
    </div>
    </template>
    
    <script>
        import emailjs from '@emailjs/browser';
        export default {
        props: ['trayImageUrl'],
        mounted() {
            emailjs.init('p60i6b7rnE2_kRckK');
        },
        data() {
            return {
            recipientEmail: '',
            senderEmail: '',
            message: '',
            submissionMessage: '',
            submissionSuccess: false,
            formSubmitted: false,
            isSubmitting: false,
            };
        },
        methods: {
            closeModal() {
                this.$emit('close');
                this.formSubmitted = false;
                this.submissionMessage = '';
                this.submissionSuccess = false;
            },
            handleSubmit() {
                const formData = {
                    recipientEmail: this.recipientEmail,
                    senderEmail: this.senderEmail,
                    message: this.message,
                    trayImageUrl: this.trayImageUrl
                };
                this.sendEmailWithTrayImage(formData);
            },
            
            resizeImage(dataUrl, maxWidth = 500, quality = 0.5) {
              return new Promise((resolve) => {
                const img = new Image();
                img.onload = () => {
                  const canvas = document.createElement('canvas');
                  const ctx = canvas.getContext('2d');
                  
                  const ratio = Math.min(maxWidth / img.width, maxWidth / img.height);
                  canvas.width = img.width * ratio;
                  canvas.height = img.height * ratio;
                  
                  ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                  resolve(canvas.toDataURL('image/jpeg', quality));
                };
                img.src = dataUrl;
              });
            },

            async sendEmailWithTrayImage(formData) {
              this.isSubmitting = true;
              try {
                let optimizedImage = formData.trayImageUrl;
                if (formData.trayImageUrl) {
                  optimizedImage = await this.resizeImage(formData.trayImageUrl, 500, 0.65);
                }
            
                const templateParams = {
                  to_email: formData.recipientEmail,
                  senderEmail: formData.senderEmail,
                  message: formData.message,
                  trayImageUrl: optimizedImage
                };
            
                await emailjs.send(
                  'service_7gy8a6k',
                  'template_68hsbi4',
                  templateParams,
                  'p60i6b7rnE2_kRckK'
                );
            
                this.submissionSuccess = true;
                this.submissionMessage = 'Email sent successfully';
                this.formSubmitted = true;
              } catch (error) {
                this.submissionSuccess = false;
                this.submissionMessage = 'Failed to send email. Please try again.';
                this.formSubmitted = true;
              } finally {
                  this.isSubmitting = false;
                }
            }
        },
        };

    </script>
    